import { useState, forwardRef } from 'react';
import PropTypes from 'prop-types';
import styles from './currencyinput.module.scss';
import { getUSCurrencyString, getNumberFromString } from './helpers';

const CurrencyInput = forwardRef(
  ({ placeholder = 'Enter up to $40,000', hasError, className = '' }, ref) => {
    const [currencyInput, setCurrencyInput] = useState('');
    const [inFocus, setIsFocus] = useState(false);
    const handleOnFocus = () => setIsFocus(true);
    const handleOnBlur = () => setIsFocus(false);
    const handleOnChange = (element) => {
      const { value } = element;
      if (value === '' || value === '$') {
        setCurrencyInput(value);
      } else {
        const numValues = getNumberFromString(value);
        if (numValues) {
          const currency = getUSCurrencyString(numValues);
          setCurrencyInput(currency);
        }
      }
    };

    const wrapperHasErrorClassName = hasError ? styles.errorWrapper : '';
    const wrapperInFocusClassName = inFocus ? styles.focusWrapper : '';
    const homePrequalCurrency =
      className === 'currencyInput' ? styles.homePrequalCurrency : '';

    let compoundClassName;
    if (className === 'currencyInput') {
      compoundClassName = `${styles.wrapper} ${wrapperHasErrorClassName} ${wrapperInFocusClassName} ${homePrequalCurrency}`;
    } else if (className) {
      compoundClassName = `${styles.wrapperPL} ${wrapperHasErrorClassName} ${wrapperInFocusClassName} ${homePrequalCurrency}`;
    } else {
      compoundClassName = `${styles.wrapper} ${wrapperHasErrorClassName} ${wrapperInFocusClassName} ${homePrequalCurrency}`;
    }

    const inputClassName = className.includes('currencyInput')
      ? styles.input
      : className || styles.input;

    return (
      <div className={compoundClassName} data-content={currencyInput}>
        {hasError && (
          <span error-span="loan-amount-error" className={styles.errorText}>
            {hasError}
          </span>
        )}
        <input
          data-testid="loan-amount"
          aria-label="Loan Amount"
          placeholder={placeholder}
          className={inputClassName}
          ref={ref}
          value={currencyInput}
          onChange={(e) => handleOnChange(e.currentTarget)}
          onFocus={() => handleOnFocus()}
          onBlur={() => handleOnBlur()}
        />
      </div>
    );
  }
);

CurrencyInput.displayName = 'Prequal';

CurrencyInput.propTypes = {
  placeholder: PropTypes.string,
  hasError: PropTypes.string,
  className: PropTypes.string,
};

export default CurrencyInput;
